"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "comazzo": {
    "2375d96d": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "caira": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17ae5ea5": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "capannone": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1fd22ca": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "castiona": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc8b42fe": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "cava": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a95ed66": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "frati": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2bee1d87": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "gardino": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0b13183": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "ghinella": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d5abe284": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "mairana": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db5274a4": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "molino-molgora": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "518c0b13": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "molino-torchio": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d22c6381": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "nuova": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96f1dbfa": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d52731ec": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "skipSearch": false
    }],
    "torchio": [{
      "hkey": "0928c0c6",
      "slug": "comazzo",
      "name": "Comazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;